// This is a type guard to filter out null and undefined values from an array
const isDefined = <T>(value: T | null | undefined): value is T =>
    value !== undefined;

// This function is very similar to the one above, but this lets us loop through specific keys
// and make sure that those keys are actually not null or undefined. This is currently used
// in the EditStyle schema to make sure that the nested objects are not null or undefined
function hasProps<T, Keys extends Array<keyof T>>(
    obj: T,
    keys: Keys
): obj is T & { [K in Keys[number]]: NonNullable<T[K]> } {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return keys.every((key) => obj[key] !== undefined && obj[key] !== null);
}

export { isDefined, hasProps };
